<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<CopyGoal @close="modalIsOpen = false" @submit="copyAllGoal" />
	</DaModalFrame>
	<div class="w-full">
		<div v-if="!studentSelected">
			<div v-if="isLoading">
				<Loading />
			</div>
			<div v-else>
				<div v-if="students && students.length > 0">
					<div class="shadow-sm sm:rounded-2xl overflow-hidden">
						<div class="__record__table overflow-x-auto scroll-bar">
							<div
								class="
									overflow-hidden
									sm:rounded-t-2xl
									w-fit
									min-w-full
								"
							>
								<table
									class="min-w-full divide-y text-neutral-200"
								>
									<thead class="bg-neutral-100 h-16">
										<tr>
											<th
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													w-16
													whitespace-nowrap
												"
											>
												STT
											</th>
											<th
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													whitespace-nowrap
												"
											>
												Tên học sinh
											</th>
											<th
												scope="col"
												class="
													px-6
													py-3
													text-left text-xs
													font-semibold
													text-neutral-600
													uppercase
													tracking-wider
													whitespace-nowrap
												"
											>
												Kế hoạch hiện tại
											</th>
											<th></th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(s, i) in students"
											:key="s.id"
											:class="
												i % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											"
											class="text-neutral-700"
										>
											<td
												class="
													px-6
													py-4
													whitespace-nowrap
													text-neutral-700
												"
											>
												<div class="ml-2">
													{{ i + 1 }}
												</div>
											</td>
											<td
												class="
													px-6
													py-4
													text-neutral-700
												"
											>
												<div class="flex items-center">
													<div class="relative">
														<img
															v-if="
																s?.student
																	?.profile_photo
																	?.w200
															"
															:src="
																s?.student
																	?.profile_photo
																	?.w200
															"
															alt=""
															class="
																shadow-sm
																inline-block
																h-6
																w-6
																rounded-full
															"
														/>
														<span
															v-else
															:style="{
																background:
																	s?.student
																		?.profile_photo
																		?.default
																		?.color,
															}"
															class="
																inline-flex
																items-center
																justify-center
																h-6
																w-6
																rounded-full
															"
														>
															<span
																class="
																	font-medium
																	leading-none
																	text-white
																	text-xs
																"
																>{{
																	s?.student
																		?.profile_photo
																		?.default
																		?.initial
																}}</span
															>
														</span>
													</div>
													<div
														class="
															ml-4
															text-orange-600
															font-semibold
															flex-1
														"
													>
														{{ s?.student?.name }}
													</div>
												</div>
											</td>
											<td
												class="
													px-6
													py-4
													text-neutral-700
												"
											>
												{{ s.name }} ({{
													s.goal_count
												}}MT)
											</td>
											<td class="px-6 py-4">
												<div
													class="
														luca-button
														px-6
														py-2
														cursor-pointer
														w-max
													"
													@click="
														selectStudent(
															s.student,
															s.id
														)
													"
												>
													Chọn
												</div>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
				<div
					v-else
					class="
						w-full
						h-full
						flex
						items-center
						justify-center
						flex-col
					"
				>
					<img
						src="@/assets/images/illustrations/not_found.png"
						alt=""
						height="250"
						width="250"
					/>
					<div class="text-neutral-600 text-center text-lg">
						Không có học sinh phù hợp
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div
				class="
					__breadcrumbs
					text-sm text-neutral-500
					font-semibold
					cursor-pointer
					items-center
					mb-6
				"
				@click="studentSelected = null"
			>
				Quay lại danh sách học sinh
			</div>
			<div v-if="isLoading">
				<Loading />
			</div>
			<div v-else>
				<div
					class="
						flex
						justify-between
						items-center
						w-full
						md-down:flex-col md-down:items-start
						gap-8
						mb-10
					"
				>
					<div class="flex items-center">
						<div class="relative">
							<img
								v-if="studentSelected?.profile_photo?.w200"
								:alt="studentSelected?.name"
								:src="studentSelected?.profile_photo?.w200"
								class="
									shadow-sm
									inline-block
									h-14
									w-14
									rounded-full
								"
								style="min-width: 56px"
							/>
							<span
								v-else
								:style="{
									background:
										studentSelected?.profile_photo?.default
											?.color,
								}"
								class="
									inline-flex
									items-center
									justify-center
									h-14
									w-14
									rounded-full
								"
								style="min-width: 56px"
							>
								<span
									class="
										font-medium
										leading-none
										text-white text-4xl
									"
									>{{
										studentSelected?.profile_photo?.default
											?.initial
									}}</span
								>
							</span>
						</div>
						<div class="ml-4">
							<div
								class="
									font-bold
									text-neutral-700 text-4xl
									md-down:text-2xl
								"
							>
								{{ studentSelected?.name }}
							</div>
						</div>
					</div>
					<button
						:class="{ 'disable-button': disabled }"
						class="luca-button"
						@click="openModal"
					>
						Sao chép toàn bộ mục tiêu
					</button>
				</div>
				<div class="p-6 bg-white shadow-sm rounded-2xl mb-10">
					<div>
						<div class="flex items-center justify-between mb-8">
							<div class="font-semibold text-neutral-600">
								Thống kê
							</div>
						</div>
					</div>
					<div class="flex flex-nowrap w-full md-down:flex-col">
						<div
							class="
								p-6
								border
								rounded-l-lg
								border-neutral-200
								w-full
								md-down:rounded-t md-down:rounded-b-none
								md:border-r-0
								md-down:border-b-0
							"
						>
							<div
								class="
									text-33
									font-bold
									text-neutral-600
									mb-6
									flex flex-nowrap
									items-center
								"
							>
								<img
									src="@/assets/images/icons/abc.png"
									alt=""
									width="32"
									height="32"
									class="mr-2"
									style="height: 32px"
								/>
								{{ skill_count }}
							</div>
							<div class="flex flex-nowrap items-center">
								<span class="text-neutral-500 text-sm"
									>Tổng số lĩnh vực
								</span>
							</div>
						</div>
						<div
							class="
								p-6
								border
								rounded-r-lg
								border-neutral-200
								w-full
								md-down:rounded-b md-down:rounded-t-none
							"
						>
							<div
								class="
									text-33
									font-bold
									text-neutral-600
									mb-6
									flex flex-nowrap
									items-center
								"
							>
								<img
									src="@/assets/images/icons/light.png"
									alt=""
									width="32"
									height="32"
									class="mr-2"
									style="height: 32px"
								/>
								{{ goal_count }}
							</div>
							<div class="flex flex-nowrap items-center">
								<span class="text-neutral-500 text-sm"
									>Tổng số mục tiêu</span
								>
							</div>
						</div>
					</div>
				</div>
				<div v-if="goals && goals.length > 0">
					<div>
						<div
							class="mb-10"
							v-for="(goal, index) in goals"
							:key="index"
						>
							<div
								class="
									font-semibold
									text-lg text-neutral-600
									mb-4
								"
							>
								{{ index + 1 }}. {{ goal.skill.name }}
							</div>
							<div
								class="shadow-sm sm:rounded-2xl overflow-hidden"
							>
								<div
									class="
										__record__table
										overflow-x-auto
										scroll-bar
									"
								>
									<div
										class="
											overflow-hidden
											sm:rounded-t-2xl
											w-fit
											min-w-full
										"
									>
										<table
											class="
												min-w-full
												divide-y
												text-neutral-200
											"
										>
											<thead class="bg-neutral-100 h-16">
												<tr>
													<th
														scope="col"
														class="
															px-6
															py-3
															text-left text-xs
															font-semibold
															text-neutral-600
															uppercase
															tracking-wider
															w-16
															whitespace-nowrap
														"
													>
														STT
													</th>
													<th
														scope="col"
														class="
															px-6
															py-3
															text-left text-xs
															font-semibold
															text-neutral-600
															uppercase
															tracking-wider
															whitespace-nowrap
														"
														style="min-width: 160px"
													>
														Nội dung
													</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr
													v-for="(g, i) in goal.goals"
													:key="g.id"
													:class="
														i % 2 === 0
															? 'bg-white'
															: 'bg-neutral-50'
													"
													class="text-neutral-700"
												>
													<td
														class="
															px-6
															py-4
															whitespace-nowrap
															text-neutral-700
														"
													>
														<div class="ml-2">
															{{ i + 1 }}
														</div>
													</td>
													<td
														class="
															px-6
															py-4
															text-neutral-700
															w-4/5
														"
													>
														<div
															class="
																flex
																items-center
																gap-2
															"
															style="width: 200px"
														>
															<router-link
																:to="`/goal/${studentSelected.id}/${g.id}`"
															>
																{{ g.name }}
															</router-link>
															<TooltipGoalDetail
																:goal-id="
																	g.goal_id ||
																	g.id
																"
																:student-id="
																	studentSelected.id
																"
															/>
														</div>
														<div
															class="
																flex
																gap-2
																flex-wrap
															"
															style="
																max-width: 360px;
															"
															v-if="
																(g?.assistance_levels &&
																	org.enable_goal_assistance_level) ||
																g?.display_source
															"
														>
															<div
																class="
																	mt-1
																	py-0.5
																	px-2.5
																	rounded-full
																	bg-neutral-200
																	text-neutral-700
																	h-fit
																	w-fit
																	font-semibold
																	shadow-input
																	whitespace-nowrap
																"
																style="
																	font-size: 10px;
																"
																v-if="
																	g?.display_source
																"
															>
																{{
																	g?.display_source
																}}
															</div>
															<template
																v-if="
																	g?.assistance_levels &&
																	org.enable_goal_assistance_level
																"
															>
																<div
																	v-for="ass in g?.assistance_levels"
																	:key="ass"
																	class="
																		flex
																		gap-2
																	"
																>
																	<div
																		class="
																			mt-1
																			py-0.5
																			px-2.5
																			rounded-full
																			bg-pink-100
																			whitespace-nowrap
																			text-neutral-700
																			h-fit
																			w-fit
																			font-semibold
																			shadow-input
																		"
																		style="
																			font-size: 10px;
																		"
																	>
																		{{
																			ass
																		}}
																	</div>
																</div>
															</template>
														</div>
													</td>
													<td>
														<div
															v-if="
																goal_added.includes(
																	g.id
																) ||
																g.used === true
															"
															class="
																button-p
																btn--text
																whitespace-nowrap
																w-56
																text-green-600
															"
														>
															<svg
																class="mr-4"
																width="20"
																height="20"
																viewBox="0 0 20 20"
																fill="none"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	fill-rule="evenodd"
																	clip-rule="evenodd"
																	d="M11.212 6.21209C11.5782 5.84597 12.1717 5.84597 12.5379 6.21209C12.8995 6.57371 12.9039 7.15727 12.5512 7.52434L7.56092 13.7622C7.55371 13.7712 7.54602 13.7798 7.53787 13.7879C7.17175 14.154 6.57816 14.154 6.21204 13.7879L2.90398 10.4799C2.53787 10.1137 2.53787 9.52015 2.90398 9.15403C3.2701 8.78791 3.86369 8.78791 4.22981 9.15403L6.84671 11.7709L11.1872 6.24013C11.1949 6.23029 11.2032 6.22093 11.212 6.21209Z"
																	fill="#2AA797"
																/>
																<path
																	fill-rule="evenodd"
																	clip-rule="evenodd"
																	d="M10.0615 12.6374L11.212 13.7879C11.5782 14.154 12.1718 14.154 12.5379 13.7879C12.546 13.7798 12.5537 13.7712 12.5609 13.7622L17.5512 7.52434C17.9039 7.15727 17.8995 6.57371 17.5379 6.21209C17.1717 5.84597 16.5782 5.84597 16.212 6.21209C16.2032 6.22093 16.1949 6.23029 16.1872 6.24013L11.8467 11.7709L11.24 11.1642L10.0615 12.6374Z"
																	fill="#2AA797"
																/>
															</svg>
															<div
																class="
																	text-green-600
																"
															>
																THÊM VÀO KH
															</div>
														</div>
														<button
															v-else
															type="button"
															class="
																button-p
																btn--text
																whitespace-nowrap
																w-56
															"
															@click="
																doGoal(g.id)
															"
														>
															Dạy MT
														</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import {
	computed,
	ref,
	onBeforeUnmount,
	watch,
	onMounted,
	defineEmits,
	defineProps,
} from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { $api } from '@/services';
import TooltipGoalDetail from '@/components/elements/tooltipGoalDetail/TooltipGoalDetail.vue';
import CopyGoal from '../copyGoal/CopyGoal.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame';
import Loading from '@/components/common/Loading';

const goal_added = computed(() => store.getters.goalAdded);
const org = computed(() => store.state.profile.current_org);
const emit = defineEmits(['updated']);
const props = defineProps(['planId', 'toGoalBank']);
const toGoalBank = ref(props.toGoalBank);
const route = useRoute();
const store = useStore();
const goals = ref([]);
const students = ref([]);
const studentSelected = ref(null);
const planSelected = ref(null);
const skill_count = ref(0);
const goal_count = ref(0);
const modalIsOpen = ref(false);
const id = computed(() => (route.params?.id ? route.params?.id : ''));
const plan_id = computed(() =>
	route.params?.plan_id ? String(route.params?.plan_id) : props.planId
);
const isLoading = ref(false);
const disabled = ref(false);

async function fetchStudent() {
	try {
		isLoading.value = true;
		const res = await $api.goal.otherStudentsPlans(id.value);
		if (res?.data) {
			students.value =
				res?.data?.data.filter((s) => s.goal_count > 0) ?? [];
		}
		isLoading.value = false;
	} catch (e) {
		await store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}
function selectStudent(student, planId) {
	planSelected.value = planId;
	studentSelected.value = student;
	studentGoalPlan();
}
async function studentGoalPlan() {
	try {
		isLoading.value = true;
		const res = await $api.goal.otherPlanGoals(
			plan_id.value,
			planSelected.value
		);
		if (res?.data) {
			goals.value = res?.data?.data?.goals_group_by_skill ?? [];
			disabled.value = goals.value.every((skill) =>
				skill.goals.every((goal) => goal.used === true)
			);
			skill_count.value = res?.data?.data?.stats.skill_count;
			goal_count.value = res?.data?.data?.stats.goal_count;
		}
		isLoading.value = false;
	} catch (e) {
		await store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}

async function doGoal(goal_id) {
	try {
		toGoalBank.value
			? await $api.goal.copyGoalToBank(plan_id.value, {
					goal_id,
			  })
			: await $api.goal.copyGoal(plan_id.value, {
					goal_id,
			  });
		store.dispatch('addGoal', goal_id);
		store.dispatch('setAlertMessage', {
			message: 'Sao chép mục tiêu thành công',
		});
		emit('updated');
	} catch (e) {
		await store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}

async function copyAllGoal() {
	try {
		toGoalBank.value
			? await $api.goal.copyAllGoalToBank(
					plan_id.value,
					planSelected.value
			  )
			: await $api.goal.copyAllGoal(plan_id.value, planSelected.value);
		store.dispatch('setAlertMessage', {
			message: 'Sao chép toàn bộ mục tiêu thành công',
		});
		modalIsOpen.value = false;
		studentGoalPlan();
		emit('updated');
	} catch (e) {
		await store.dispatch('setAlertMessage', {
			message:
				e?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
}

function openModal() {
	if (disabled.value) return;
	modalIsOpen.value = true;
}

const reload = computed(() => store.getters.reload);

watch(reload, () => {
	fetchStudent();
});
onMounted(() => {
	fetchStudent();
});
onBeforeUnmount(() => {
	store.dispatch('clearAdded');
});
</script>
